// Base styles
import * as cardIndexStatic from "assets/components-static-styles/components/card/index";
// Base styles
import colors from "assets/theme/base/colors";
import borders from "assets/theme/base/borders";

//  Helper Function
import rgba from "assets/theme/functions/rgba";

const { black, white } = colors;
const { borderWidth } = borders;
// Helper Functions
import { merge } from "lodash";

// types
type Types = any;

const themeStyles: Types = {
  styleOverrides: {
    root: {
      backgroundColor: white.main,
      border: `${borderWidth[0]} solid ${rgba(black.main, 0.125)}`,
    },
  },
};

const card = merge(themeStyles, cardIndexStatic.default);

export default card;
